module.exports = __webpack_public_path__ + "img/code-img.da2ca1c9.png";